"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_FAILURE = exports.UPDATE_SUCCESS = exports.UPDATE_REQUEST = exports.CREATE_FAILURE = exports.CREATE_SUCCESS = exports.CREATE_REQUEST = exports.SWITCH_ACTIVE = void 0;
exports.SWITCH_ACTIVE = 'workspaces/SWITCH_ACTIVE/SUCCESS';
exports.CREATE_REQUEST = 'workspaces/CREATE/REQUEST';
exports.CREATE_SUCCESS = 'workspaces/CREATE/SUCCESS';
exports.CREATE_FAILURE = 'workspaces/CREATE/FAILURE';
exports.UPDATE_REQUEST = 'workspaces/UPDATE/REQUEST';
exports.UPDATE_SUCCESS = 'workspaces/UPDATE/SUCCESS';
exports.UPDATE_FAILURE = 'workspaces/UPDATE/FAILURE';
//# sourceMappingURL=types.js.map